import { Box, Stack, useMediaQuery, useTheme } from "@mui/material";
import CardUsdt from "../components/CardUsdt";
import CardKotaro from "../components/CardKotaro";
import { useLocation } from "react-router-dom";
import { useUserData } from "../hooks/use-data-user";

const CompraInicial = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const type = searchParams.get("type");

  return (
    <Box
      sx={{
        display: "flex",
        width: "100%",
        minHeight: "100vh",
        backgroundImage: "url(/assets/bg-payments.png)",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          height: "auto",
          backgroundColor: "rgba(0, 0, 0, 0.714)",
          backdropFilter: "blur(6px)",
          zIndex: 9,
          padding: "10px",
          marginTop: { xs: "25px", xxl: 0 },
        }}
      >
        <Box
          component="img"
          src="/assets/plusvalica_logo.svg"
          alt="Logo Plusvalica"
          width={500}
          height={60}
          style={{
            maxWidth: "100%",
            height: "auto",
          }}
        />

        <Stack
          direction={{ xs: "column", lg: "row" }}
          justifyContent="center"
          alignItems="center"
          width="100%"
          maxWidth="1200px"
          spacing={4}
          paddingX={{ xs: "0px", md: "20px" }}
          paddingY="20px"
        >
          {(type === "usdt" || !type) && <CardUsdt />}
          {(type === "kotaro" || !type) && <CardKotaro />}
        </Stack>
      </Box>
    </Box>
  );
};

export default CompraInicial;
